/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/oAuth2PermissionGrantOperationsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a OAuth2PermissionGrantOperations. */
var OAuth2PermissionGrantOperations = /** @class */ (function () {
    /**
     * Create a OAuth2PermissionGrantOperations.
     * @param {GraphRbacManagementClientContext} client Reference to the service client.
     */
    function OAuth2PermissionGrantOperations(client) {
        this.client = client;
    }
    OAuth2PermissionGrantOperations.prototype.list = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, listOperationSpec, callback);
    };
    OAuth2PermissionGrantOperations.prototype.create = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, createOperationSpec, callback);
    };
    OAuth2PermissionGrantOperations.prototype.deleteMethod = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, deleteMethodOperationSpec, callback);
    };
    OAuth2PermissionGrantOperations.prototype.listNext = function (nextLink, options, callback) {
        return this.client.sendOperationRequest({
            nextLink: nextLink,
            options: options
        }, listNextOperationSpec, callback);
    };
    return OAuth2PermissionGrantOperations;
}());
export { OAuth2PermissionGrantOperations };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/oauth2PermissionGrants",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.filter,
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.OAuth2PermissionGrantListResult
        },
        default: {
            bodyMapper: Mappers.CloudError
        }
    },
    serializer: serializer
};
var createOperationSpec = {
    httpMethod: "POST",
    path: "{tenantID}/oauth2PermissionGrants",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.OAuth2PermissionGrant
    },
    responses: {
        201: {
            bodyMapper: Mappers.OAuth2PermissionGrant
        },
        default: {
            bodyMapper: Mappers.CloudError
        }
    },
    serializer: serializer
};
var deleteMethodOperationSpec = {
    httpMethod: "DELETE",
    path: "{tenantID}/oauth2PermissionGrants/{objectId}",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listNextOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/{nextLink}",
    urlParameters: [
        Parameters.nextLink,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.OAuth2PermissionGrantListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=oAuth2PermissionGrantOperations.js.map